<template>
    <div>
        <div class="action">
            <span class="icon_back" :class="{disable:!enableBack}">
                <font-awesome-icon icon="backward" class="icon" @click="back"/>
            </span>

            <font-awesome-icon v-if="isPlaying" icon="pause" class="icon" @click="pause"/>
            <font-awesome-icon v-else icon="play" class="icon" @click="play"/>
            <span class="icon_next" :class="{disable:!enableNext}">
                <font-awesome-icon icon="forward" class="icon" @click="next"/>
            </span>
        </div>

        <div class="slider">
            <player-slider :player-status="playerStatus" @change="onSliderChange"/>
        </div>

        <div class="audio-player">
            <audio
                :src="music.content"
                ref="audio"
                v-on:timeupdate="OnTimeupdate"
                v-on:loadedmetadata="OnLoadedmetadata"
                v-on:ended="OnEnded"
            ></audio>
        </div>
    </div>
</template>

<script>
import {ref} from '@vue/reactivity';
import {Toast} from 'vant';
import PlayerSlider from "@/components/playerSlider";

export default {
    name: 'MusicPlayer',
    components: {PlayerSlider},
    props:{
        music:{
            type:Object,
            require:true
        },
        enableBack:{
            type:Boolean
        },
        enableNext: {
            type:Boolean
        }
    },
    setup() {
        return {
            isPlaying: ref(false),
            // 播放器状态
            playerStatus:ref({
                current:0,// 当前时间点
                duration:1, // 总时长
            }),
        };
    },
    methods:{
        back(){
            if(this.enableBack){
                this.$emit('back')
            }
        },
        play(){
            this.$refs.audio.play().then(() => {
                this.isPlaying = true
            }).catch(err => {
                console.error(err)
                Toast.fail('播放失败！')
            })
        },
        pause(){
            this.$refs.audio.pause()
            this.isPlaying = false
        },
        next(){
            if(this.enableNext){
                this.$emit('next')
            }
        },
        /** 进度发生变化 */
        onSliderChange(value){
            const player = this.$refs.audio
            const current = (value / 100.0) * player.duration
            // 设置播放时间
            player.currentTime = current
            this.playerStatus = {current,duration: player.duration}
        },
        /** 加载音频信息 */
        OnLoadedmetadata(res) {
            const target = res.target
            this.playerStatus = {
                current:target.currentTime,
                duration:target.duration
            }
        },
        OnTimeupdate(res) {
            const target = res.target
            this.playerStatus = {
                current:target.currentTime,
                duration:target.duration
            }
        },
        /** 播放完毕，自动切歌 */
        OnEnded(){
            this.pause() // 暂停
            this.next() // 切歌
        }
    }
}
</script>

<style scoped>
.action {
    text-align: center;
    color: #fff;
    font-size: 40px;
}

.icon {
    width: 20vw;
    cursor: pointer;
}

.icon_back.disable{
    cursor: not-allowed;
    color: rgba(78, 78, 78, 0.4);
}
.icon_next.disable{
    cursor: not-allowed;
    color: rgba(78, 78, 78, 0.4);
}
.slider {
    margin-top: 40px;
    padding: 10px;
}
.audio-player{
    width: 0;
    height: 0;
}
</style>

